export const SystemAnalysisTableConfig = {
  Evaporators: {
    headers: ["Equipment ID", "Location", "Design Capacity (TR)", "Issue Type", "Description",],
    mapping: {
      "Equipment ID": "EquipmentName",
      Location: "location",
      "Design Capacity (TR)": "capacity",
      "Issue Type": "Type",
      Description: "Description",
    }
  },
  "Heat Exchangers": {
    headers: ["Equipment ID", "Heat Exchanger Type", "Location", "Design Capacity (TR)", "Issue Type", "Description"],
    mapping: {
      "Equipment ID": "EquipmentName",
      "Heat Exchanger Type": `subType`,
      Location: "location",
      "Design Capacity (TR)": "capacity",
      "Issue Type": "Type",
      Description: "Description",
    }
  },
  Compressors: {
    headers: ["Equipment ID", "Type", "Location", "Design Capacity (TR)", "Load (TR)", "Issue Type", "Description"],
    mapping: {
      "Equipment ID": "EquipmentName",
      Type: "subType",
      Location: "location",
      "Design Capacity (TR)": "designCapacity",
      "Load (TR)": "operatingCapacity",
      "Issue Type": "Type",
      Description: "Description",
    }
  },
  Condensers: {
    headers: ["Equipment ID", "Type", "Location", "Design Capacity (TR)", "Load (TR)", "Issue Type", "Description"],
    mapping: {
      "Equipment ID": "EquipmentName",
      Type: "subType",
      Location: "location",
      "Design Capacity (TR)": "designCapacity",
      "Load (TR)": "condenserLoad",
      // "Load (MBH)": "",
      "Issue Type": "Type",
      Description: "Description",
    }
  },
  Vessels: {
    headers: ["Equipment ID", "Vessels Type", "Location", "Design Capacity (TR)", "Load (TR)", "Issue Type", "Description"],
    mapping: {
      "Equipment ID": "EquipmentName",
      "Vessels Type": "subType",
      Location: "location",
      "Design Capacity (TR)": "designCapacity",
      "Load (TR)": "operatingCapacity",
      "Issue Type": "Type",
      Description: "Description",
    }
  },
  "Air Handlers": {
    headers: ["Equipment ID", "Location", "Design Capacity (TR)", "Issue Type", "Description"],
    mapping: {
      "Equipment ID": "EquipmentName",
      "Vessels Type": "subType",
      Location: "location",
      "Design Capacity (TR)": "capacity",
      // "Load (MBH)": "",
      "Issue Type": "Type",
      Description: "Description",
    }
  },
  "Valve Stations": {
    headers: ["Equipment ID", "Make", "Location", "Issue Type", "Description"],
    mapping: {
      "Equipment ID": "EquipmentName",
      "Make": "make",
      Location: "location",
      "Issue Type": "Type",
      Description: "Description",
    }
  },
};
